import * as React from 'react';
import { RouteObject } from 'react-router-dom';

const ClientProfile = React.lazy(
    () => import(/* webpackChunkName: "client-profile-reports" */ '../../../../containers/Client/Profile')
);

export const ClientProfileRoutes: RouteObject = {
    path: 'profile',
    element: (
        <React.Suspense fallback={<>...</>}>
            <ClientProfile />
        </React.Suspense>
    )
};
